/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum BankAccountApprovalMode {
    MANUAL_APPROVAL = 'MANUAL_APPROVAL',
    AUTO_APPROVE_VALIDATED = 'AUTO_APPROVE_VALIDATED',
    AUTO_APPROVE_ALL = 'AUTO_APPROVE_ALL',
}
